import { FixConversation } from "./FixConversation";

class FixConversations {
  public static readonly EMPTY = new FixConversation(
    null,
    null,
    "Any Conversation"
  );

  static getOrCreate(items: Array<FixConversation>, from: string, to: string) {
    const filtered = items.filter(function (item) {
      return (
        (item.party1 === from && item.party2 === to) ||
        (item.party1 === to && item.party2 === from)
      );
    });
    if (filtered.length === 0) {
      const conversation = new FixConversation(from, to);
      items.push(conversation);
      return conversation;
    } else {
      return filtered[0];
    }
  }
}

export { FixConversations };
